import { render } from "./SupportComponent.vue?vue&type=template&id=24622533&scoped=true"
import script from "./SupportComponent.vue?vue&type=script&lang=js"
export * from "./SupportComponent.vue?vue&type=script&lang=js"

import "./SupportComponent.vue?vue&type=style&index=0&id=24622533&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24622533"]])

export default __exports__